export default __webpack_public_path__ + "static/media/services_car_tech_check_place.6e65c48a.svg";